import {txt, type Texto} from '../i18n/idioma';

// Nota de cada campo de una exportacion (Daniel, 14/10/2026): que es y como se
// llena. La usan la tabla del seguimiento (titulo de cada columna), el
// formulario de editar y de nueva exportacion, y la ficha de la exportacion.
// "El Status" = la hoja Tracking Status de Status Concentrates Shipments.
export const AYUDA_SEGUIMIENTO = {
  codigo: txt(
    'Código de la exportación: la llave que la une con los archivos, los Big Bags y los documentos. Sale de la columna Export de la hoja Tracking Status (Status Concentrates Shipments) o se escribe al crear la exportación.',
    'Export code: the key that links it to the files, the Big Bags and the documents. It comes from the Export column of the Tracking Status sheet (Status Concentrates Shipments) or is typed when the export is created.',
  ),
  tipo: txt(
    'Propia, De terceros o Mineros. Al cargar el Status, Exporter = Third Party la deja De terceros y los códigos que empiezan por MA quedan de Mineros. Se puede cambiar al editar.',
    'Own, Third party or Mineros. When the Status is loaded, Exporter = Third Party makes it Third party and codes starting with MA become Mineros. It can be changed when editing.',
  ),
  estado: txt(
    'En qué va el envío (Pending, In sea transit, Arrived, Delivered…). Sale de la columna STATUS del Status; la revisión de la naviera lo hace avanzar solo con hechos reales (zarpe, llegada, contenedor devuelto). Se edita en la app.',
    'Where the shipment stands (Pending, In sea transit, Arrived, Delivered…). It comes from the STATUS column of the Status; the shipping line check only moves it forward with real events (departure, arrival, container returned). It is edited in the app.',
  ),
  exportador: txt(
    'Empresa que exporta. Sale de la columna Exporter del Status; si está vacía, se toma del prefijo del código (Exportaciones → Prefijos). Se edita en la app.',
    'Exporting company. It comes from the Exporter column of the Status; if empty, it is taken from the code prefix (Exports → Prefixes). It is edited in the app.',
  ),
  agente: txt(
    'Agente de carga que maneja el envío. Columna Agent del Status; se edita en la app.',
    'Freight agent handling the shipment. Agent column of the Status; it is edited in the app.',
  ),
  naviera: txt(
    'Naviera que lleva los contenedores. Columna Shipping Company del Status; si está vacía, la llena la reserva vinculada. Se edita en la app.',
    'Shipping line carrying the containers. Shipping Company column of the Status; if empty, the linked booking fills it. It is edited in the app.',
  ),
  booking: txt(
    'Número de la reserva con la naviera. Columna Booking del Status o la reserva (PDF de la naviera) vinculada; se edita en la app.',
    'Booking number with the shipping line. Booking column of the Status or the linked booking (shipping line PDF); it is edited in the app.',
  ),
  buque: txt(
    'Buque y viaje. Columna Vessel del Status; también lo actualizan la reserva vinculada y la revisión de la naviera.',
    'Vessel and voyage. Vessel column of the Status; the linked booking and the shipping line check also update it.',
  ),
  rastreo: txt(
    'Enlace a la página de rastreo de la naviera. Lo arma la app con la naviera y el booking cuando conoce esa página; si no, sale —.',
    'Link to the shipping line tracking page. The app builds it from the shipping line and the booking when it knows that page; otherwise it shows —.',
  ),
  puertoCarga: txt(
    'Puerto donde se embarca la carga. Columna Port of Loading del Status (o del Consolidated Shipments); se edita en la app.',
    'Port where the cargo is loaded. Port of Loading column of the Status (or of the Consolidated Shipments); it is edited in the app.',
  ),
  puertoDestino: txt(
    'Puerto de llegada. Columna Destination Port del Status; se edita en la app.',
    'Arrival port. Destination Port column of the Status; it is edited in the app.',
  ),
  etd: txt(
    'Fecha estimada de zarpe del puerto inicial. Columna ETD del Status; la actualizan la reserva vinculada y la revisión de la naviera. Cada cambio queda en el historial de fechas.',
    'Estimated departure date from the first port. ETD column of the Status; the linked booking and the shipping line check update it. Every change is kept in the date history.',
  ),
  etaMundra: txt(
    'Llegada estimada al puerto de destino en India (Mundra, Pipavav...). Columna ETA Mundra /Pipavav del Status; la actualizan la reserva, el rastreo y la revisión de la naviera: manda la más reciente y al lado se ve de dónde salió.',
    'Estimated arrival at the destination port in India (Mundra, Pipavav...). ETA Mundra /Pipavav column of the Status; the booking, the tracker and the shipping line check update it: the most recent wins and its source is shown next to it.',
  ),
  etaSachana: txt(
    'Llegada estimada al destino final (Sachana). Columna ETA Sachana del Status; la actualizan la reserva, el rastreo y la revisión de la naviera: manda la más reciente.',
    'Estimated arrival at the final destination (Sachana). ETA Sachana column of the Status; the booking, the tracker and the shipping line check update it: the most recent wins.',
  ),
  etaHindustan: txt(
    'Llegada estimada a Hindustan, el destino final. Columna ETA Hindustan del Status; se edita en la app.',
    'Estimated arrival at Hindustan, the final destination. ETA Hindustan column of the Status; it is edited in the app.',
  ),
  eta: txt(
    'La llegada vigente al destino final. La calcula la app: ETA Hindustan; si no hay, ETA Sachana; si no, ETA Mundra. Se puede escribir a mano.',
    'The current arrival at the final destination. The app works it out: ETA Hindustan; if none, ETA Sachana; otherwise ETA Mundra. It can be typed by hand.',
  ),
  etaInicial: txt(
    'La primera ETA que tuvo la exportación, para medir retrasos. La app la guarda sola con la primera ETA y no la cambia después; se puede corregir a mano.',
    'The first ETA the export had, to measure delays. The app stores it on its own with the first ETA and does not change it afterwards; it can be corrected by hand.',
  ),
  diasParaLlegada: txt(
    'Días que faltan para la ETA destino (negativo si ya pasó). Lo calcula la app con la fecha de hoy.',
    'Days left to the destination ETA (negative if it has passed). The app works it out with today’s date.',
  ),
  fechaZarpe: txt(
    'Día en que el buque salió de verdad. Viene de la columna Departure del Consolidated Shipments o de la revisión de la naviera cuando informa el zarpe real; se edita en la app.',
    'Day the vessel actually sailed. It comes from the Departure column of the Consolidated Shipments or from the shipping line check when it reports the real departure; it is edited in the app.',
  ),
  fechaLlegada: txt(
    'Día en que la carga llegó de verdad al puerto de destino. Columna Arrival del Consolidated Shipments o la llegada real que informa la naviera; se edita en la app.',
    'Day the cargo actually reached the destination port. Arrival column of the Consolidated Shipments or the real arrival reported by the shipping line; it is edited in the app.',
  ),
  fechaTren: txt(
    'Día en que el contenedor salió en tren del puerto de India hacia Sachana (Date on rake). Lo trae la revisión de la naviera, solo cuando es real; se edita en la app.',
    'Day the container left the Indian port by rail towards Sachana (Date on rake). The shipping line check brings it, only when it is real; it is edited in the app.',
  ),
  puertoActual: txt(
    'Dónde está la carga ahora (o el último puerto del que salió); puede ser de transbordo. Lo trae la revisión de la naviera.',
    'Where the cargo is now (or the last port it left); it may be a transshipment port. The shipping line check brings it.',
  ),
  etdPuertoActual: txt(
    'Zarpe (real o estimado) desde el puerto actual. Lo trae la revisión de la naviera; la ETD sigue siendo la del puerto inicial.',
    'Departure (actual or estimated) from the current port. The shipping line check brings it; the ETD is still the one from the first port.',
  ),
  fechaLlegadaHindustan: txt(
    'Día en que la carga llegó a Hindustan. Columna Hindustan Arrival Date del Consolidated Shipments; se edita en la app.',
    'Day the cargo arrived at Hindustan. Hindustan Arrival Date column of the Consolidated Shipments; it is edited in the app.',
  ),
  fechaBl: txt(
    'Fecha del BL (conocimiento de embarque). Columna BL Date del Consolidated Shipments; se edita en la app.',
    'Date of the BL (bill of lading). BL Date column of the Consolidated Shipments; it is edited in the app.',
  ),
  fechaLiquidacion: txt(
    'Fecha de la liquidación final de la venta. Columna Liquidation Date del Consolidated Shipments o del Status; se edita en la app.',
    'Date of the final settlement of the sale. Liquidation Date column of the Consolidated Shipments or of the Status; it is edited in the app.',
  ),
  diasLibres: txt(
    'Días libres en puerto que da la naviera antes de cobrar. Columna Free Days del Status, o los de la reserva vinculada; se edita en la app.',
    'Free days in port the shipping line gives before charging. Free Days column of the Status, or those of the linked booking; it is edited in the app.',
  ),
  diasEnTransito: txt(
    'Días de viaje reales: ETA destino menos zarpe real, calculados por la app. Sin zarpe real o sin ETA queda lo que traía el Status o se escribió a mano.',
    'Actual days of travel: destination ETA minus actual departure, worked out by the app. Without an actual departure or ETA it keeps what the Status had or what was typed in.',
  ),
  diasEnTransitoInicial: txt(
    'Días de viaje que se planearon: ETA inicial menos ETD. Lo calcula la app.',
    'Planned days of travel: initial ETA minus ETD. The app works it out.',
  ),
  bigBags: txt(
    'Cantidad de Big Bags de la exportación. La app cuenta las bolsas ligadas en el inventario; si no tiene, usa la cantidad reportada (BB QTY del Status).',
    'Number of Big Bags in the export. The app counts the bags linked in inventory; if there are none, it uses the reported quantity (BB QTY in the Status).',
  ),
  bigBagsReportados: txt(
    'Cantidad de Big Bags que dice el Status (columna BB QTY). Se ve aparte para compararla con las bolsas del inventario; se edita en la app.',
    'Number of Big Bags stated in the Status (BB QTY column). It is shown separately to compare it with the bags in inventory; it is edited in the app.',
  ),
  contenedores: txt(
    'Cuántos contenedores tienen Big Bags en la exportación; uno vacío no cuenta. Si la exportación no tiene Big Bags, cuentan los de su logística. Lo cuenta la app.',
    'How many containers of the export have Big Bags; an empty one does not count. If the export has no Big Bags, those of its logistics count. The app counts them.',
  ),
  tonHumedas: txt(
    'Toneladas húmedas (WMT). Suma de los Big Bags de la exportación (pesos del Consolidated Shipments); sin bolsas, lo reportado que se escriba en la app.',
    'Wet tonnes (WMT). Sum of the export’s Big Bags (weights from the Consolidated Shipments); without bags, the reported value typed in the app.',
  ),
  tonSecas: txt(
    'Toneladas secas (DMT). Suma de los Big Bags de la exportación; sin bolsas, la columna DMT del Status.',
    'Dry tonnes (DMT). Sum of the export’s Big Bags; without bags, the DMT column of the Status.',
  ),
  auG: txt(
    'Gramos de oro. Suma de los Big Bags de la exportación; sin bolsas, la columna Au g del Status.',
    'Grams of gold. Sum of the export’s Big Bags; without bags, the Au g column of the Status.',
  ),
  auOz: txt(
    'Onzas troy de oro. Suma de los Big Bags de la exportación; sin bolsas, la columna Au Oz del Status.',
    'Troy ounces of gold. Sum of the export’s Big Bags; without bags, the Au Oz column of the Status.',
  ),
  agG: txt(
    'Gramos de plata. Suma de los Big Bags de la exportación; sin bolsas, la columna Ag gr del Status.',
    'Grams of silver. Sum of the export’s Big Bags; without bags, the Ag gr column of the Status.',
  ),
  agOz: txt(
    'Onzas troy de plata. Suma de los Big Bags de la exportación; sin bolsas, la columna Ag Oz del Status.',
    'Troy ounces of silver. Sum of the export’s Big Bags; without bags, the Ag Oz column of the Status.',
  ),
  comprador: txt(
    'Empresa que compra la carga. Columna Sold to del Consolidated Shipments; se edita en la app.',
    'Company buying the cargo. Sold to column of the Consolidated Shipments; it is edited in the app.',
  ),
  incoterm: txt(
    'Condición de entrega de la venta (CIF, FOB…). Se escribe en la app.',
    'Delivery terms of the sale (CIF, FOB…). It is typed in the app.',
  ),
  valorAproximadoUsd: txt(
    'Valor aproximado de la exportación en dólares. Columna Approximate Value USD del Status; se edita en la app.',
    'Approximate value of the export in dollars. Approximate Value USD column of the Status; it is edited in the app.',
  ),
  facturadora: txt(
    'Empresa del grupo que factura la venta. Columna Invoicing Company del Status; se edita en la app.',
    'Group company that invoices the sale. Invoicing Company column of the Status; it is edited in the app.',
  ),
  factura: txt(
    'Números de factura registrados para la exportación: el de la columna Invoice Number del Status, los del GEX FR08 y los que se escriben al generar los documentos de aduana.',
    'Invoice numbers recorded for the export: the one in the Invoice Number column of the Status, those from the GEX FR08 and those typed when generating the customs documents.',
  ),
  xau: txt(
    'Precio del oro usado en la venta, en USD por onza. Columna XAU del Status; se edita en la app.',
    'Gold price used in the sale, in USD per ounce. XAU column of the Status; it is edited in the app.',
  ),
  xag: txt(
    'Precio de la plata usado en la venta, en USD por onza. Columna XAG del Status; se edita en la app.',
    'Silver price used in the sale, in USD per ounce. XAG column of the Status; it is edited in the app.',
  ),
  fechaLbma: txt(
    'Fecha de la fijación del precio en LBMA. Columna LBMA del Status; se edita en la app.',
    'Date of the LBMA price fixing. LBMA column of the Status; it is edited in the app.',
  ),
  financiadaPorBlq: txt(
    'Si la exportación fue financiada por BLQ (Sí o No). Columna Financed by BLQ del Consolidated Shipments; se edita en la app.',
    'Whether the export was financed by BLQ (Yes or No). Financed by BLQ column of the Consolidated Shipments; it is edited in the app.',
  ),
  tonHumedasReportadas: txt(
    'Toneladas húmedas de una exportación sin Big Bags en el inventario. El Status no las trae: se escriben en la app.',
    'Wet tonnes of an export without Big Bags in inventory. The Status does not bring them: they are typed in the app.',
  ),
  tonSecasReportadas: txt(
    'Toneladas secas de una exportación sin Big Bags en el inventario. Columna DMT del Status; se edita en la app.',
    'Dry tonnes of an export without Big Bags in inventory. DMT column of the Status; it is edited in the app.',
  ),
  auGReportados: txt(
    'Gramos de oro de una exportación sin Big Bags en el inventario. Columna Au g del Status; se edita en la app.',
    'Grams of gold of an export without Big Bags in inventory. Au g column of the Status; it is edited in the app.',
  ),
  agGReportados: txt(
    'Gramos de plata de una exportación sin Big Bags en el inventario. Columna Ag gr del Status; se edita en la app.',
    'Grams of silver of an export without Big Bags in inventory. Ag gr column of the Status; it is edited in the app.',
  ),
  auOzReportadas: txt(
    'Onzas de oro de una exportación sin Big Bags en el inventario. Columna Au Oz del Status; se edita en la app.',
    'Ounces of gold of an export without Big Bags in inventory. Au Oz column of the Status; it is edited in the app.',
  ),
  agOzReportadas: txt(
    'Onzas de plata de una exportación sin Big Bags en el inventario. Columna Ag Oz del Status; se edita en la app.',
    'Ounces of silver of an export without Big Bags in inventory. Ag Oz column of the Status; it is edited in the app.',
  ),
  notas: txt(
    'Notas libres del equipo sobre la exportación. Se escriben en la app.',
    'Free notes from the team about the export. They are typed in the app.',
  ),

  // Solo en la ficha de la exportacion.
  ultimoEvento: txt(
    'Último hecho real que informó la naviera (zarpe, llegada, descargue…), con el lugar y la fecha. Lo trae la revisión de la naviera.',
    'Last real event reported by the shipping line (departure, arrival, discharge…), with place and date. The shipping line check brings it.',
  ),
  navieraConsultadaEl: txt(
    'Última vez que la app consultó el booking con la naviera, sola cada día o con el botón Consultar naviera.',
    'Last time the app checked the booking with the shipping line, automatically every day or with the Check shipping line button.',
  ),
  avance: txt(
    'Qué parte del viaje va recorrida entre la ETD y la ETA destino. Lo calcula la app con la fecha de hoy; es una estimación.',
    'How much of the voyage has been covered between the ETD and the destination ETA. The app works it out with today’s date; it is an estimate.',
  ),
} satisfies Record<string, Texto>;

// Nota de un campo o columna por su nombre (undefined si no tiene).
export const ayudaDeCampo = (id: string): Texto | undefined => (AYUDA_SEGUIMIENTO as Record<string, Texto>)[id];

// Filtros de la tabla del seguimiento.
export const AYUDA_FILTROS_SEGUIMIENTO = {
  buscar: txt(
    'Busca por exportación, booking, buque, factura, agente, naviera o puerto. Basta con una parte del texto.',
    'Searches by export, booking, vessel, invoice, agent, shipping line or port. Part of the text is enough.',
  ),
  estado: txt(
    'Deja solo las exportaciones en los estados que marques. Se pueden marcar varios.',
    'Keeps only the exports in the statuses you tick. You can tick several.',
  ),
  exportador: txt(
    'Deja solo las exportaciones de los exportadores que marques (el de la exportación o el de su prefijo).',
    'Keeps only the exports of the exporters you tick (the export’s own or its prefix’s).',
  ),
  mesEtd: txt(
    'Mes de la ETD (zarpe estimado). "Sin ETD" muestra las que todavía no la tienen.',
    'Month of the ETD (estimated departure). "No ETD" shows those that do not have one yet.',
  ),
  mesEta: txt(
    'Mes de la ETA destino (llegada vigente). "Sin ETA" muestra las que todavía no la tienen.',
    'Month of the destination ETA (current arrival). "No ETA" shows those that do not have one yet.',
  ),
  tipo: txt('Propia, De terceros o Mineros.', 'Own, Third party or Mineros.'),
  naviera: txt(
    'Deja solo las exportaciones de las navieras que marques.',
    'Keeps only the exports of the shipping lines you tick.',
  ),
  facturadora: txt(
    'Deja solo las exportaciones que factura la empresa del grupo que marques.',
    'Keeps only the exports invoiced by the group company you tick.',
  ),
  etdDesde: txt(
    'Muestra las exportaciones con ETD (zarpe estimado) desde este día, incluido.',
    'Shows the exports with an ETD (estimated departure) from this day on, inclusive.',
  ),
  etdHasta: txt(
    'Muestra las exportaciones con ETD (zarpe estimado) hasta este día, incluido.',
    'Shows the exports with an ETD (estimated departure) up to this day, inclusive.',
  ),
  etaDesde: txt(
    'Muestra las exportaciones con ETA destino desde este día, incluido.',
    'Shows the exports with a destination ETA from this day on, inclusive.',
  ),
  etaHasta: txt(
    'Muestra las exportaciones con ETA destino hasta este día, incluido.',
    'Shows the exports with a destination ETA up to this day, inclusive.',
  ),
} satisfies Record<string, Texto>;
